import { inject, Injectable } from '@angular/core'

import { UserProfile, UserSnapshot } from '@ti/contracts'
import { ApiService } from '@ti/core/api'
import { RealtimeClient } from '@ti/core/realtime'
import { BaseScopedUsersStore, UserDirectoryKind, UserStoreEventBus } from '@ti/shared/user/stores'

@Injectable({ providedIn: 'root' })
export class FleetUsersStore extends BaseScopedUsersStore<UserProfile> {
  protected readonly api = inject(ApiService)
  protected readonly events = inject(UserStoreEventBus)
  protected readonly realtimeClient = inject(RealtimeClient)

  public constructor() {
    super()
    this.events.connectRealtime(this.realtimeClient)
    this.connectEvents(this.events, UserDirectoryKind.Fleet, () => ({ scope: undefined }))
  }

  protected scopeKey(): string {
    return 'fleet'
  }

  protected loadPage(_scope: void, page: number, pageSize: number): Promise<UserProfile[]> {
    return this.api.fleet.user.list({ page, pageSize, order: 'ASC', orderBy: 'id' })
  }

  protected loadByIds(_scope: void, ids: string[]): Promise<UserProfile[]> {
    return this.api.fleet.user.list({ page: 0, pageSize: ids.length, filter: { id: ids } })
  }

  protected loadSnapshot(): Promise<UserSnapshot[]> {
    return this.api.fleet.user.snapshot()
  }
}
